import React from 'react';
import Authenticated from 'Components/Layouts/Authenticated';
import { Container } from "Components/Utilities";

const TARGET_DATE = new Date('2025-10-15T07:30:00Z');

export default class HoldingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getTimeRemaining();
        this.introVideoRef = React.createRef();
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState(this.getTimeRemaining());
        }, 1000);

        if (this.introVideoRef.current) {
            this.introVideoRef.current.addEventListener('ended', this.handleVideoEnd);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        if (this.introVideoRef.current) {
            this.introVideoRef.current.removeEventListener('ended', this.handleVideoEnd);
        }
    }

    getTimeRemaining() {
        const now = new Date().getTime();
        const distance = TARGET_DATE - now;
        return {
            days: String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0'),
            hours: String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
            minutes: String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
            seconds: String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0'),
        };
    }

    handleVideoEnd = () => {
        const mainpage = document.getElementById('mainpage');
        if (mainpage) {
            mainpage.scrollIntoView({ behavior: 'smooth' });
        }
    };

    render() {
        const { days, hours, minutes, seconds } = this.state;

        return (
            <Authenticated title="Dashboard" pageVideoHeader={null}>
                <div className="w-full h-full flex flex-col text-left bg-app-blue text-white">
                    <video
                        className="w-full"
                        autoPlay
                        muted
                        playsInline
                        id="intro-video"
                        ref={this.introVideoRef}
                    >
                        <source
                            src="/images/landing-page/banner.mp4"
                            type="video/mp4"
                        />
                    </video>
                </div>
                <div className="w-full flex flex-col text-left bg-light-blue py-20 text-white">
                    <div className="max-w-6xl mx-auto w-full">
                        <div id="countdown" className="flex flex-row gap-4 py-10 justify-center bg-[#007bcd]">
                            <div className="time-box text-center flex flex-col items-center p-5 md:p-10">
                                <span className="time-value text-2xl md:text-6xl font-medium">{days}</span>
                                <span className="time-label text-xl">Days</span>
                            </div>
                            <div className="time-box text-center flex flex-col items-center p-5 md:p-10">
                                <span className="time-value text-2xl md:text-6xl font-medium">{hours}</span>
                                <span className="time-label text-xl">Hours</span>
                            </div>
                            <div className="time-box text-center flex flex-col items-center p-5 md:p-10">
                                <span className="time-value text-4xl md:text-6xl font-medium">{minutes}</span>
                                <span className="time-label text-xl">Minutes</span>
                            </div>
                            <div className="time-box text-center flex flex-col items-center p-5 md:p-10">
                                <span className="time-value text-4xl md:text-6xl font-medium">{seconds}</span>
                                <span className="time-label text-xl">Seconds</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full bg-white flex flex-col text-center" id="mainpage">
                    <div className="max-w-6xl mx-auto w-full mb-6">
                        <div className="flex justify-center items-center">
                            <div className="w-full flex justify-center items-center text-white">
                                <div className="relative h-full w-full">
                                    <img
                                        src="/images/landing-page/text.png"
                                        className="w-full h-full object-cover"
                                        alt="Bupa Symposium live stream will show here on 15th October 2025"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Authenticated>
        );
    }
}
